export const RESIZE_HANDLE_WIDTH = 4;
export const RESIZE_HANDLE_ID = 'table-resize-handle';
